module.exports = __webpack_public_path__ + "static/media/package.ffe282c5.svg";